@let isMobile = breakpoints() === "mobile";
@let isRDVDOM = this.isRDVDOM();
@let _userType = userType();
@let activeSpecs = _userType === "professionnel" ? proSpecs() : specs();
<section>
  <div class="container">
    <div class="row">
      <div class="col-lg-7 col-xs-12">
        <app-title [titles]="[title()]" class="title" />
        <p class="sub-title">Tous les champs sont obligatoires</p>
      </div>
      <div class="col-lg-12 col-xs-12 content">
        <div class="form">
          <div class="radio-group step">
            <ng-container [ngTemplateOutlet]="radioLabel" [ngTemplateOutletContext]="{ userType: 'particulier' }" />
            <ng-container [ngTemplateOutlet]="radioLabel" [ngTemplateOutletContext]="{ userType: 'professionnel' }" />
          </div>

          <!-- STEP 1 -->
          <div class="step step-one">
            <div class="form-item">
              Heureux de vous rencontrer
              <ng-container [ngTemplateOutlet]="nameInput" />
            </div>
            @if (_userType === "professionnel") {
              <div class="form-item">
                Votre société se nomme
                <ng-container [ngTemplateOutlet]="companyInput" />
              </div>
            }
            <div class="form-item">
              Votre projet concerne
              <ng-container [ngTemplateOutlet]="projectInput" />
            </div>
          </div>

          <!-- STEP 2 -->
          @if (0 | isStepVisible: form : _userType) {
            <div @fadeInOut class="step step-two">
              <div class="form-item">
                {{ _userType === "professionnel" ? "Vous souhaitez collaborer avec" : "Votre agenceur" }}
                <div
                  [class.form-item-input--dashed-selected]="!!form['location']"
                  class="form-item-input form-item-input--dashed">
                  <span (click)="openStoreDialog(location)" class="modal-input">{{
                    storeSelected() ? storeSelected() : "choisir une boutique"
                  }}</span>
                </div>
              </div>
              <div class="form-item form-item--flex-wrap">
                {{ _userType === "professionnel" ? "qui" : "" }} aura le plaisir de
                <ng-container [ngTemplateOutlet]="appointmentTypeInput" />
                <div>
                  <span>le </span>
                  <div
                    [class.form-item-input--dashed-selected]="dateStart()"
                    class="form-item-input form-item-input--dashed">
                    <span (click)="openDateDialog(date, askStore, askType)" class="modal-input">{{
                      dateStart() ? (dateStart() | date: "EEE dd MMMM, 'à' HH:mm") : "choisir un jour"
                    }}</span>
                  </div>
                </div>
              </div>
              @if (isRDVDOM && !!form["dateStart"]) {
                <div class="form-item form-item--flex-wrap">
                  <span>au</span>
                  <ng-container [ngTemplateOutlet]="addressStreetInput" />
                  <ng-container [ngTemplateOutlet]="addressNumberInput" />
                  <ng-container [ngTemplateOutlet]="addressCityInput" />
                </div>
              }
            </div>
          }

          <!-- STEP 3 -->
          @if ((isRDVDOM ? 3 : 1) | isStepVisible: form : _userType) {
            <div @fadeInOut class="step step-three">
              @if (isMobile) {
                <div class="form-item">
                  Nous pouvons vous joindre
                  <div>
                    <span>au </span>
                    <ng-container [ngTemplateOutlet]="phoneInput" />
                  </div>
                  <div>
                    <span>Et à l'adresse </span>
                    <ng-container [ngTemplateOutlet]="emailInput" />
                  </div>
                </div>
              } @else {
                <div class="form-item">
                  Nous pouvons vous joindre au
                  <ng-container [ngTemplateOutlet]="phoneInput" />
                </div>
                <div class="form-item">
                  <span>Et à l'adresse </span>
                  <ng-container [ngTemplateOutlet]="emailInput" />
                </div>
              }
            </div>
          }

          <!-- STEP 4 -->
          @if (_userType === "particulier" && ((isRDVDOM ? 4 : 2) | isStepVisible: form : _userType)) {
            <div @fadeInOut class="step step-four">
              <app-form-item (value)="updateForm($event)" [specs]="activeSpecs.optin" [theme]="'FILL'" />
              <app-button
                (buttonClicked)="onSuccess()"
                [icon]="{ name: 'CHEVRON_RIGHT' }"
                [isLoading]="isLoading()"
                [label]="'Valider votre RDV'" />
              <div class="send-error" role="alert">
                @if (isSendFailed()) {
                  <div class="error error-dashed">
                    Votre demande n'a pas pu être envoyée. Réessayez ou contactez votre boutique.
                  </div>
                }
              </div>
            </div>
          }
          @if (_userType === "professionnel" && ((isRDVDOM ? 4 : 2) | isStepVisible: form : _userType)) {
            <div @fadeInOut class="step step-four">
              <app-form-item (value)="updateForm($event)" [specs]="activeSpecs.optin" [theme]="'FILL'" />
              <app-button
                (buttonClicked)="onSuccess()"
                [icon]="{ name: 'CHEVRON_RIGHT' }"
                [isLoading]="isLoading()"
                [label]="'Valider votre RDV'" />
              <div class="send-error" role="alert">
                @if (isSendFailed()) {
                  <div class="error error-dashed">
                    Votre demande n'a pas pu être envoyée. Réessayez ou contactez votre boutique.
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</section>

<dialog #location class="dialog dialog-location">
  <ng-container [ngTemplateOutlet]="dialogLocationContent" />
</dialog>
<dialog #date class="dialog dialog-date">
  <ng-container [ngTemplateOutlet]="dialogDateContent" />
</dialog>
<dialog #askStore class="dialog dialog-ask-store">
  <ng-container [ngTemplateOutlet]="dialogAskStoreContent" />
</dialog>
<dialog #askType class="dialog dialog-ask-type">
  <ng-container [ngTemplateOutlet]="dialogAskTypeContent" />
</dialog>

<!--TEMPLATES – inputs-->
<ng-template #radioLabel let-userType="userType">
  <label class="radio-label">
    <input
      (change)="selectUserType(userType)"
      [checked]="_userType === userType"
      name="userType"
      type="radio"
      [value]="userType" />
    Je suis un {{ userType }}
  </label>
</ng-template>

<ng-template #nameInput>
  <div class="form-item-input">
    <app-form-item
      (value)="updateForm($event)"
      [customStyle]="{ width: isMobile ? '20rem' : '38rem' }"
      [debounceTime]="1000"
      [resetTrigger]="resetFormTrigger()"
      [specs]="activeSpecs.name"
      [theme]="'DASHED'" />
    <span class="dot">.</span>
  </div>
</ng-template>

<ng-template #companyInput>
  <div class="form-item-input">
    <app-form-item
      (value)="updateForm($event)"
      [customStyle]="{ width: isMobile ? '24rem' : '46rem' }"
      [debounceTime]="1000"
      [specs]="proSpecs().company"
      [theme]="'DASHED'" />
    <span class="dot">.</span>
  </div>
</ng-template>

<ng-template #projectInput>
  <div class="form-item-input">
    <app-form-item
      (value)="updateForm($event)"
      [customStyle]="{ width: isMobile ? '25rem' : '48rem' }"
      [isMobile]="isMobile"
      [resetTrigger]="resetFormTrigger()"
      [specs]="activeSpecs.project"
      [theme]="'DASHED'" />
    @if (!isMobile) {
      <span class="dot">.</span>
    }
  </div>
</ng-template>

<ng-template #appointmentTypeInput>
  <div (click)="checkStoreSelected(askStore)" class="form-item-input">
    <app-form-item
      (value)="updateForm($event)"
      [customStyle]="{ width: isMobile ? '23rem' : '45rem' }"
      [isMobile]="isMobile"
      [resetTrigger]="resetTypeForm()"
      [specs]="activeSpecs.type"
      [theme]="'DASHED'"
      class="form-item-input" />
    @if (!isMobile) {
      <span class="coma">,</span>
    }
  </div>
</ng-template>

<ng-template #addressStreetInput>
  <div class="form-item-input">
    <app-form-item
      (value)="updateForm($event)"
      [customStyle]="{ width: isMobile ? '20rem' : '38rem' }"
      [debounceTime]="1000"
      [specs]="specs().addressStreet"
      [theme]="'DASHED'" />
  </div>
</ng-template>

<ng-template #addressNumberInput>
  <div class="form-item-input">
    <app-form-item
      (value)="updateForm($event)"
      [customStyle]="{ width: isMobile ? '10rem' : '19rem' }"
      [debounceTime]="1000"
      [specs]="specs().zipcode"
      [theme]="'DASHED'" />
  </div>
</ng-template>

<ng-template #addressCityInput>
  <div class="form-item-input">
    <app-form-item
      (value)="updateForm($event)"
      [customStyle]="{ width: isMobile ? '15rem' : '28.5rem' }"
      [debounceTime]="1000"
      [specs]="specs().city"
      [theme]="'DASHED'" />
  </div>
</ng-template>

<ng-template #phoneInput>
  <div class="form-item-input">
    <app-form-item
      (value)="updateForm($event)"
      [customStyle]="{ width: isMobile ? '26rem' : '50rem' }"
      [debounceTime]="1000"
      [resetTrigger]="resetFormTrigger()"
      [specs]="activeSpecs.phone"
      [theme]="'DASHED'" />
    <span class="dot">.</span>
  </div>
</ng-template>

<ng-template #emailInput>
  <div class="form-item-input">
    <app-form-item
      (value)="updateForm($event)"
      [customStyle]="{ width: isMobile ? '20rem' : '40rem' }"
      [debounceTime]="1000"
      [resetTrigger]="resetFormTrigger()"
      [specs]="activeSpecs.email"
      [theme]="'DASHED'" />
    <span class="dot">.</span>
  </div>
</ng-template>

<!--TEMPLATES – dialogs-->
<ng-template #dialogLocationContent>
  <button (click)="closeLocationDialog(location)" class="dialog-close">Annuler</button>
  @if (isGoogleApiLoaded()) {
    <div class="dialog-content">
      <div class="dialog-location-find">Trouver la boutique la plus proche de chez vous</div>
      <app-search
        (resetClick)="onReset()"
        (suggestionClick)="onAroundMeClick()"
        (valueInput)="onLocationValueInput($event)"
        [placeholder]="'Saisir la ville où se situe votre projet'"
        [suggestion]="locationAround()"
        [value]="locationSelected()" />
      @if (isDisplay().storeLoading) {
        <div class="loading">
          <div class="spinner spinner--white"></div>
        </div>
      }
      <div class="dialog-location-results">
        <app-dropdown
          (selected)="onLocationSelected($event)"
          [isOpen]="locationItems().length > 0"
          [isScroll]="true"
          [items]="locationItems()" />
      </div>
      @if (isDisplay().proximityStores) {
        <div class="dialog-location-suggestion">
          <div class="text">Boutiques à proximité</div>
          <app-dropdown
            (selected)="onStoreSelected($event); closeLocationDialog(location)"
            [isOpen]="true"
            [isScroll]="true"
            [items]="storeSuggestions()" />
        </div>
      }
      @if (isDisplay().storeNotFound) {
        <div class="dialog-location-no-results">
          <p class="text">
            Il n'y a, actuellement, aucune boutique Perene dans votre secteur. <br />
            Que souhaitez-vous faire ?
          </p>
          <app-button
            [icon]="{ name: 'CHEVRON_RIGHT', color: 'BLACK' }"
            [theme]="'WHITE'"
            class="button"
            label="Être rappelé par notre service client" />
          <app-button
            [icon]="{ name: 'CHEVRON_RIGHT', color: 'BLACK' }"
            [theme]="'WHITE'"
            class="button"
            label="Effectuer une nouvelle recherche" />
        </div>
      }
      @if (isDisplay().suggestions) {
        <div class="dialog-location-suggestion">
          <div class="text">Suggestions de recherches</div>
          <app-dropdown
            (selected)="onLocationSelected($event)"
            [isOpen]="true"
            [isScroll]="true"
            [items]="locationSuggestions()" />
        </div>
      }
    </div>
  }
</ng-template>

<ng-template #dialogDateContent>
  @if (storeUuid() && availableDays()) {
    <button (click)="closeDateDialog(date)" class="dialog-close">Annuler</button>
    <div class="dialog-content">
      @if (dialogDateIsOpened()) {
        <app-date-picker
          (date)="onSelectedDate($event); closeDateDialog(date)"
          [availableDays]="availableDays()"
          [storePhoneNumber]="storePhoneNumber()"
          [storeUuid]="storeUuid()!" />
      }
    </div>
  }
</ng-template>

<ng-template #dialogAskStoreContent>
  <button (click)="closeAskStoreDialog(askStore)" class="dialog-close">Annuler</button>
  <div class="dialog-content">
    <div class="dialog-ask-store-choose">
      <p class="text">Merci de choisir votre agenceur Perene</p>
      <app-button
        (click)="closeAskStoreDialog(askStore); openStoreDialog(location)"
        [icon]="{ name: 'CHEVRON_RIGHT' }"
        [theme]="'FULL_WHITE'"
        label="Choisir mon agenceur" />
    </div>
  </div>
</ng-template>

<ng-template #dialogAskTypeContent>
  <div class="dialog-content">
    <div class="dialog-ask-store-choose">
      <p class="text">Merci de choisir votre type de rendez-vous</p>
      <app-button (click)="askType.close()" [icon]="{ name: 'CHEVRON_RIGHT' }" [theme]="'FULL_WHITE'" label="Retour" />
    </div>
  </div>
</ng-template>
